<template>
	<div>
		<el-dialog title="等级权益配置"
		:visible.sync="openDialog"
		width="800px"
		:before-close="handleDialogCloseAnoths"
		>
		<div style="height: 500px;overflow: auto;" v-loading="loading">
			<div class="title">请选择当前等级（ <span style="color:#7B61FF">{{formData.name}} </span>）的等级权益：</div>
			<div style="margin: 20px 0">* 选中保存即展示在会员权益处，顺序数值越小展示越前。若权益状态变更为“禁用”，则重新启用后需要再次勾选才展示</div>
			<el-form
				:model="formData"
				ref="formData"
				class="backgroundForm"
				label-width="150px"
				style="margin-top:20px "
			>

			
			<el-form-item label="权益分类">
					<el-select v-model="formData.benefitCategoryId" @change="getBenefitInfoList">
          	<el-option v-for="(item, index) in benefitCategoryList" :key="index" :value="item.id" :label="item.name"></el-option>
        	</el-select>
				</el-form-item>

			<el-form-item>
					<el-checkbox-group v-model="resourceIds" @change="handleChange">
						<el-checkbox v-for="(item,index) in resourList" :label="item.id" :key="index">{{item.name}}</el-checkbox>
					</el-checkbox-group>
			</el-form-item>


			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
				<el-button @click="cancelAdd" class="cancel_Btn">取 消</el-button>
				<el-button type="primary" class="sure_Btn" @click="saveData()">确 定</el-button>
		</span>
		</el-dialog>
	</div>
</template>

<script>
import { getCategoryList,getBenefitInfo,saveBenefit} from "@/api/brandCustom/brandMemberCenter";
export default {
	props:{
		openDialog:{
			type:Boolean,
		},
		editData:{
			type:Object
		}
	},
	data() {
		return {
			loading:false,
			formData:{
				benefitCategoryId:'',
			},
			benefitCategoryList:[],//权益分类
			resourList:[],//权益列表
			resourceIds:[],
		}
	},
	mounted() {
		this.formData = JSON.parse(JSON.stringify(this.editData))
		this.formData.benefitCategoryId =''
		console.log("this.formData",this.formData)
		this.getBenefitCategoryList()
	},
	methods: {
		//获取权益分类
		getBenefitCategoryList(){
			this.loading = true
			getCategoryList().then((res) => {
				this.loading=false
				if (res.code == 1) {
					this.benefitCategoryList = res.data
					this.benefitCategoryList.unshift({
						id: '',
						name: '全部'
					})
					this.getBenefitInfoList()
				}else{
					this.$message.error(res.message);
				}
			});
		},
		getBenefitInfoList(){
			this.loading = true
			let params = {
				benefitCategoryId:this.formData.benefitCategoryId,
				levelId:this.formData.id
			}

			getBenefitInfo(params).then((res) => {
				this.loading=false
				if (res.code == 1) {
					this.resourList = res.data
					this.resourceIds = res.data.map((item) => item.selected == true ? item.id : null).filter(item => item !== null)
					console.log("resourList",this.resourList);
					console.log("resourceIds",this.resourceIds);
				}else{
					this.$message.error(res.message);
				}
			});
		},
		handleChange(){},
		//保存
		saveData(){
			let params = {
				resourceIds:this.resourceIds,
				levelId:this.formData.id
			}

			saveBenefit(params).then((res) => {
				if (res.code == 1) {
					this.$message.success("操作成功");
					this.$emit('saveData')
				}else{
					this.$message.error(res.message);
				}
			});
		},
		// 取消添加
		cancelAdd() {
			this.$emit('cancel')
		},

		handleDialogCloseAnoths() {
			this.$emit('cancel')
		}
	},
}
</script>

<style lang="scss" scoped>
.title{
	color:#333;
	font-size: 20px;
	margin:10px;
}
/deep/.hide_box .el-upload--picture-card{
    display: none;
}
</style>